export default __webpack_public_path__ + "static/media/header-kanan.f6946754.png";